export default __webpack_public_path__ + "static/image-online-shop-9c6305e6f614a9ce24bbfb510e9f5e30.png";